var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 768,
    viewBox: "0 0 1366 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18.1465 776.579H1377.92V-8.70734H-18.1465V776.579Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.538 513.806H284.221V556.936H105.538V513.806Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.737 449.67L751.532 323.875L781.895 354.238L656.1 480.033L625.737 449.67Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.645 607.613L509.384 480.174L540.342 449.414L668.604 576.853L637.645 607.613Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.417 798.473L570.622 671.034L600.985 640.273L726.78 767.713L696.417 798.473Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103 200.378H75.612V244.265H-103V200.378Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-103 566.023L-72.6368 596.386L-24.9211 548.67L22.7948 596.386L53.1579 566.023L5.44211 518.307L53.1579 470.591L22.7948 440.228L-24.9211 487.944L-72.6368 440.228L-103 470.591L-55.2842 518.307L-103 566.023Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.995 254.728L174.358 285.091L222.074 237.375L269.79 285.091L300.153 254.728L252.437 207.012L300.153 159.296L269.79 128.933L222.074 176.649L174.358 128.933L143.995 159.296L191.711 207.012L143.995 254.728Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.382 10.7947L440.943 41.1579L488.971 -6.5579L536.999 41.1579L567.56 10.7947L519.533 -36.9211L567.56 -84.6368L536.999 -115L488.971 -67.2842L440.943 -115L410.382 -84.6368L458.41 -36.9211L410.382 10.7947Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.082 640.53L376.445 670.893L424.16 623.177L471.876 670.893L502.239 640.53L454.524 592.814L502.239 545.098L471.876 514.735L424.16 562.451L376.445 514.735L346.082 545.098L393.797 592.814L346.082 640.53Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.819 432.063C343.445 432.063 331.793 443.715 331.793 458.089C331.793 472.462 343.445 484.116 357.819 484.116C372.193 484.116 383.845 472.462 383.845 458.089C383.845 443.715 372.193 432.063 357.819 432.063Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.819 357.556C372.193 357.556 383.845 346.133 383.845 332.041C383.845 317.949 372.193 306.524 357.819 306.524C343.445 306.524 331.793 317.949 331.793 332.041C331.793 346.133 343.445 357.556 357.819 357.556Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.125 416.753V372.866H269.534V416.753H447.125Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2608 749.96C66.8965 760.125 66.898 776.603 77.2608 786.766C87.6236 796.931 104.426 796.931 114.789 786.766C125.152 776.603 125.153 760.124 114.789 749.96C104.426 739.797 87.6236 739.797 77.2608 749.96Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5588 666.687C39.523 656.922 39.523 641.089 29.5588 631.325C19.5946 621.558 3.43844 621.558 -6.52576 631.325C-16.4914 641.089 -16.4914 656.922 -6.52576 666.687C3.43844 676.452 19.5932 676.453 29.5588 666.687Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.199 659.963L137.444 659.218L107.586 629.745L106.831 629L-20 754.195L-19.2453 754.94L10.6133 784.413L11.368 785.158L138.199 659.963Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4412 26.869C82.8155 26.869 94.4675 15.2158 94.4675 0.843376C94.4675 -13.532 82.8155 -25.1837 68.4412 -25.1837C54.0668 -25.1837 42.4149 -13.532 42.4149 0.843376C42.4149 15.2158 54.0668 26.869 68.4412 26.869Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4675 101.376C54.0932 101.376 42.4412 112.799 42.4412 126.891C42.4412 140.983 54.0932 152.408 68.4675 152.408C82.8418 152.408 94.4938 140.983 94.4938 126.891C94.4938 112.799 82.8418 101.376 68.4675 101.376Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 43V85.8669H162.612V43H-16Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.577 67.6945C656.952 67.6945 668.604 56.0429 668.604 41.6689C668.604 27.295 656.952 15.6419 642.577 15.6419C628.203 15.6419 616.551 27.295 616.551 41.6689C616.551 56.0429 628.203 67.6945 642.577 67.6945Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.577 142.201C628.203 142.201 616.551 153.853 616.551 168.227C616.551 182.601 628.203 194.254 642.577 194.254C656.952 194.254 668.604 182.601 668.604 168.227C668.604 153.853 656.952 142.201 642.577 142.201Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.271 84.0247V127.912H731.883V84.0247H553.271Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.64 118.398C399.605 108.432 399.604 92.2774 389.64 82.3132C379.676 72.3476 363.519 72.3476 353.555 82.3132C343.591 92.2774 343.59 108.434 353.555 118.398C363.519 128.362 379.676 128.362 389.64 118.398Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.681 188.459C448.716 198.423 448.716 214.58 458.681 224.544C468.645 234.509 484.801 234.508 494.765 224.544C504.731 214.58 504.731 198.423 494.765 188.459C484.801 178.495 468.646 178.494 458.681 188.459Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.082 200.852L346.827 201.602L376.3 231.268L377.045 232.018L502.239 106.005L501.494 105.255L472.021 75.5888L471.276 74.839L346.082 200.852Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.982 760.231C465.947 750.066 465.946 733.588 455.982 723.425C446.017 713.26 429.861 713.26 419.897 723.425C409.932 733.588 409.932 750.067 419.897 760.231C429.861 770.394 446.017 770.394 455.982 760.231Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.423 842.632L413.178 843.387L443.036 873.245L443.791 874L570.622 747.169L569.868 746.414L540.009 716.556L539.254 715.801L412.423 842.632Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.166 694.754V627.005H227.054V694.756H159.304V737.868H227.054V805.617H270.166V737.867H337.916V694.754H270.166Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.994 366.108V298.359H101.129V366.11H33.7657V409.222H101.129V476.971H143.994V409.221H211.357V366.108H143.994Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.821 -18.6731V-86.4221H240.955V-18.6716H173.593V24.4408H240.955V92.1898H283.821V24.4394H351.185V-18.6731H283.821Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.993 298.112V229.976H546.127V298.114H478.765V341.473H546.127V409.609H588.993V341.471H656.356V298.112H588.993Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.86 241.203H1096.25V199.357H1274.86V241.203Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.689 165.676L860.484 291.471L830.121 321.834L704.326 196.039L734.689 165.676Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.442 -27.225L848.236 98.5698L817.873 128.933L692.078 3.13818L722.442 -27.225Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.78 561.684H1339.16V518.817H1517.78V561.684Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.91 151.131L1444.35 120.768L1396.32 168.484L1348.29 120.768L1317.73 151.131L1365.76 198.847L1317.73 246.563L1348.29 276.926L1396.32 229.21L1444.35 276.926L1474.91 246.563L1426.88 198.847L1474.91 151.131Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.86 515.698L1244.5 485.136L1196.78 533.164L1149.07 485.136L1118.71 515.698L1166.42 563.725L1118.71 611.753L1149.07 642.315L1196.78 594.287L1244.5 642.315L1274.86 611.753L1227.15 563.725L1274.86 515.698Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.023 747.383L955.66 716.821L907.944 764.849L860.228 716.821L829.865 747.383L877.581 795.411L829.865 843.438L860.228 874L907.944 825.972L955.66 874L986.023 843.438L938.307 795.411L986.023 747.383Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.22 137.04L1014.66 106.479L966.631 154.506L918.603 106.479L888.041 137.04L936.069 185.068L888.041 233.096L918.603 263.657L966.631 215.63L1014.66 263.657L1045.22 233.096L997.192 185.068L1045.22 137.04Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.04 337.143C1075.41 337.143 1087.07 325.492 1087.07 311.118C1087.07 296.744 1075.41 285.091 1061.04 285.091C1046.67 285.091 1035.01 296.744 1035.01 311.118C1035.01 325.492 1046.67 337.143 1061.04 337.143Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.04 413.691C1046.67 413.691 1035.01 425.343 1035.01 439.717C1035.01 454.091 1046.67 465.744 1061.04 465.744C1075.41 465.744 1087.07 454.091 1087.07 439.717C1087.07 425.343 1075.41 413.691 1061.04 413.691Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.734 353.474V398.382H1149.33V353.474H971.734Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.86 64.9044L1275.62 65.6591L1305.48 95.5177L1306.23 96.2724L1433.06 -30.5587L1432.31 -31.3135L1402.45 -61.1721L1401.69 -61.9268L1274.86 64.9044Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.29 733.152C1355.92 733.152 1344.27 744.803 1344.27 759.177C1344.27 773.551 1355.92 785.204 1370.29 785.204C1384.67 785.204 1396.32 773.551 1396.32 759.177C1396.32 744.803 1384.67 733.152 1370.29 733.152Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.29 657.624C1384.67 657.624 1396.32 646.43 1396.32 632.619C1396.32 618.809 1384.67 607.613 1370.29 607.613C1355.92 607.613 1344.27 618.809 1344.27 632.619C1344.27 646.43 1355.92 657.624 1370.29 657.624Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.62 716.821V673.955H1282.01V716.821H1460.62Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.281 665.789C761.907 665.789 750.255 677.213 750.255 691.305C750.255 705.397 761.907 716.821 776.281 716.821C790.656 716.821 802.308 705.397 802.308 691.305C802.308 677.213 790.656 665.789 776.281 665.789Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.281 590.262C790.656 590.262 802.308 578.609 802.308 564.237C802.308 549.863 790.656 538.209 776.281 538.209C761.907 538.209 750.255 549.863 750.255 564.237C750.255 578.609 761.907 590.262 776.281 590.262Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.587 648.439V605.572H686.975V648.439H865.587Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.37 650.958C1019.2 661.123 1019.2 677.601 1029.37 687.764C1039.53 697.929 1056.01 697.929 1066.17 687.764C1076.34 677.601 1076.34 661.121 1066.17 650.958C1056.01 640.794 1039.53 640.794 1029.37 650.958Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.029 581.618C970.192 571.455 970.192 554.975 960.029 544.812C949.865 534.647 933.386 534.649 923.222 544.812C913.057 554.975 913.057 571.455 923.222 581.618C933.386 591.782 949.864 591.783 960.029 581.618Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.8 568.557L1073.04 567.802L1043.18 537.944L1042.43 537.189L915.599 664.02L916.353 664.775L946.212 694.633L946.967 695.388L1073.8 568.557Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.006 -1.23083C951.841 8.93414 951.843 25.412 962.006 35.5755C972.169 45.7404 988.649 45.7404 998.812 35.5755C1008.98 25.412 1008.98 8.93266 998.812 -1.23083C988.649 -11.3943 972.169 -11.3943 962.006 -1.23083Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.44 -83.632L1005.68 -84.3867L975.822 -114.245L975.067 -115L848.236 11.8312L848.991 12.5859L878.85 42.4445L879.604 43.1992L1006.44 -83.632Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.01 75.86V143.222H1158.12V75.8585H1225.87V32.9924H1158.12V-34.3695H1115.01V32.9939H1047.26V75.86H1115.01Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.4 397.608V465.744H1325.51V397.606H1393.26V354.248H1325.51V286.111H1282.4V354.249H1214.65V397.608H1282.4Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.16 789.921V857.67H1184.03V789.919H1251.39V746.807H1184.03V679.058H1141.16V746.808H1073.8V789.921H1141.16Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.62 472.502V540.251H872.978V472.5H941.115V429.388H872.978V361.639H829.62V429.389H761.482V472.502H829.62Z",
    fill: "#DCE4E6",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImg);
export default __webpack_public_path__ + "static/media/BackgroundImg.cf67d38dcf836be0d7df6508a2ba6b31.svg";
export { ForwardRef as ReactComponent };